import React, { useState, useEffect, useCallback, Fragment, lazy } from 'react';
import Edit from '../../../componentes/edit/edit-dialog';
import Input from '../../../componentes/input';
import { Row, Col } from 'src/componentes/grid';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { capitalizeFirstLetter } from '../../../utils/string';
import ColaboradorEGrupoSimplificadoLookup from '../../../lookups/ColaboradorEGrupoSimplificadoLookup';
import TipoPeriodicidadePontoControle from '../../../lookups/tipo-periodicidade-ponto-controle';
import TipoPontoControle from '../../../lookups/tipo-ponto-controle';
import http from 'src/services/httpService';
import CheckBox from '../../../componentes/checkbox';
import InputNumber from '../../../componentes/input-number';
import TipoEvidenciaLookup from '../../../lookups/tipo-evidencia';
import CalendarioLookup from '../../../lookups/calendario';
import TipoToleranciaLookup from '../../../lookups/tipo-tolerancia';
import AreaLookup from 'src/lookups/item-organizacao';
import DesenharCampoCustomizado from '../../item/campo-customizado/componentes/desenhar';
import RecorrenciaPeriodicidade from './recorrencia-periodicidade';
import Panel from '../../../componentes/panel';
import PanelCollapse from 'src/componentes/panel-collapse';
import Tooltip from 'src/componentes/tooltip';
import FuncaoPontoControlelookup from '../../../lookups/funcao-pontocontrole';
import FrequenciaControleLookup from 'src/lookups/frequencia-controle';
import PontoControleLookup from 'src/lookups/ponto-controle';
import ContentManager from 'src/componentes/content-manager';
import Confirm from 'src/componentes/message-box/confirm';
import ValidacaoRestricao from 'src/paginas/item/validacao-restricao';
import Tabs from 'src/componentes/tabs/tabs';
import Tab from 'src/componentes/tabs/tab';
import IndicadoresRiscoControleView from './controle-indicador-risco/view';
import ConfirmNew from 'src/componentes/NewConfirm';
import RevisaoPontoControleList from 'src/paginas/gestao-risco/risco/RevisaoPontoControle/RevisaoPontoControleListView';
import Acao from 'src/paginas/NewGantt';
import { FILTROS, COLUNAS, ADDONS } from 'src/utils/constants';
import useAuth from 'src/hooks/useAuth';
import errorHandler from 'src/utils/error-handler';
import schema from './schema';

export { schema };

const Historico = lazy(() => import('src/paginas/versao-alteracao'));
const TesteControleView = lazy(() =>
  import('src/paginas/gestao-risco/teste-controle/TesteControleView')
);

export function PontoControleEditForm({
  model,
  resources,
  disabled,
  tipoInclusao,
  itemOrigem,
  setChangeEfetividade,
  handleCloseEdit,
  showConfirmMsg = false,
  showRevisoesControle = true,
  riscoControleView = false,
  ...rest
}) {
  const intl = useIntl();
  const [config, setConfig] = useState({});
  const [configuracaoRisco, setConfiguracaoRisco] = useState({});
  const { addons } = useAuth();
  const possuiAddonTesteControle =
    addons?.find((x) => x.id === ADDONS.TESTE_CONTROLE && x.ativo) != null;

  const isDisabled =
    disabled || model.getModel('permissions').value
      ? !model.getModel('permissions').getModel('allowEdit').value
      : false;

  const getConfigurations = useCallback(async () => {
    try {
      const response = await http.get(
        `/PontoControleConfiguracao/ObterConfiguracoes`
      );
      setConfig(response.data);
    } catch (err) {
      errorHandler(err);
    }
  }, []);

  const getConfigurationsRisco = useCallback(async () => {
    try {
      const response = await http.get(
        `/ItemConfiguracaoRisco/ObterConfiguracoes`
      );
      setConfiguracaoRisco(response.data);
    } catch (err) {
      errorHandler(err);
    }
  }, []);

  useEffect(() => {
    getConfigurations();
  }, [getConfigurations]);

  useEffect(() => {
    getConfigurationsRisco();
  }, [getConfigurationsRisco]);

  if (!config) {
    return null;
  }

  const handleMensagemAlteracaoResponsavel = (value) => {
    ContentManager.addContent(
      <ConfirmNew
        showCancel={true}
        primaryMessage={intl.formatMessage(
          {
            id: 'msgConfirmacaoMudancaResponsavelControleRisco',
          },
          {
            pontodecontrole: resources?.pontodecontrole?.toLowerCase(),
            risco: resources?.risco?.toLowerCase(),
            responsavel: resources?.responsavel?.toLowerCase(),
          }
        )}
        onSaved={() => {
          model.getModel('responsavel').requestChange(value);
        }}
      />
    );
  };

  const requestChangeResponsavel = (value) => {
    if (showConfirmMsg && value && value.id > 0) {
      handleMensagemAlteracaoResponsavel(value);
    } else {
      model.getModel('responsavel').requestChange(value);
    }
  };

  const handleMensagemAlteracaoValidadores = (value) => {
    ContentManager.addContent(
      <ConfirmNew
        showCancel={true}
        primaryMessage={intl.formatMessage(
          {
            id: 'msgConfirmacaoMudancaValidadoresControleRisco',
          },
          {
            pontodecontrole: resources?.pontodecontrole?.toLowerCase(),
            risco: resources?.risco?.toLowerCase(),
            revisoesdecontrole: resources?.revisoesdecontrole?.toLowerCase(),
          }
        )}
        onSaved={() => {
          model.getModel('validadores').requestChange(value);
        }}
      />
    );
  };

  const requestChangeValidadores = (value) => {
    if (showConfirmMsg && value) {
      handleMensagemAlteracaoValidadores(value);
    } else {
      model.getModel('validadores').requestChange(value);
    }
  };

  const handleChangeEfetividade = (value) => {
    model.getModel('funcaoPontoControle').requestChange(value);
    setChangeEfetividade && setChangeEfetividade();
  };

  const controleTipoAgrupado = () =>
    (tipoInclusao && tipoInclusao === 2) ||
    (model && model.getModel('agrupador') && model.getModel('agrupador').value);

  const bloquearCodigoAutomatico =
    config.model &&
    config.model.permitirAlterarCodigoAutomatico == false &&
    config.model.utilizarCodigoAutomatico == true
      ? true
      : false;
  const utilizarCodigoAutomatico =
    config.model && config.model.utilizarCodigoAutomatico;
  const ehPeriodicidadeConformeCalendario =
    model.getModel('periodicidade').value &&
    model.getModel('periodicidade').value.id === 10;
  const anexoObrigatorio = config.model && config.model.anexoObrigatorio;
  const periodicidadeObrigatoria =
    model.getModel('frequenciaControle').value &&
    model.getModel('frequenciaControle').value.id === 1
      ? true
      : false;
  const ehFrequenciaControleConstante =
    model.getModel('frequenciaControle').value &&
    model.getModel('frequenciaControle').value.id === 2
      ? true
      : false;
  const ehFrequenciaControleOcorrencia =
    model.getModel('frequenciaControle').value &&
    model.getModel('frequenciaControle').value.id === 3
      ? true
      : false;
  const exibirAnexoObrigatorio =
    anexoObrigatorio &&
    model.getModel('frequenciaControle').value &&
    (model.getModel('frequenciaControle').value.id == 1 ||
      ehFrequenciaControleConstante ||
      ehFrequenciaControleOcorrencia);
  const responsavelObrigatorio =
    config.model && config.model.responsavelObrigatorio;
  const agrupador = controleTipoAgrupado();
  const controlePai =
    model &&
    model.getModel('controlePai') &&
    model.getModel('controlePai').value;
  const alterarPasta = (value) => {
    if (
      model &&
      model.getModel('id') &&
      model.getModel('id').value > 0 &&
      controlePai &&
      controlePai > 0
    ) {
      ContentManager.addContent(
        <ValidacaoRestricao
          url="/PontoControle/ValidarRestricoes"
          item={model.getModel().value}
          isEdit={true}
          validarAlteracao={true}
          atualizar={(handleClose) => {
            model.getModel('controlePai').requestChange(value);
            handleClose && handleClose();
          }}
        />
      );
    } else {
      model.getModel('controlePai').requestChange(value);
    }
  };

  if (
    agrupador &&
    model &&
    model.getModel('agrupador') &&
    !model.getModel('agrupador').value
  ) {
    model.getModel('agrupador').requestChange(agrupador);
  }

  const controleId =
    model && model.getModel('id') && model.getModel('id').value;

  if (itemOrigem && (!controlePai || controlePai.id !== itemOrigem.id)) {
    const pastaOrigem = { id: itemOrigem.id, descricao: itemOrigem.descricao };
    model.getModel('controlePai').requestChange(pastaOrigem);
  }

  const renderInput = (children) => (
    <Tooltip
      hideArrow
      disabled={!riscoControleView}
      text={intl.formatMessage(
        { id: 'labelCampoBloqueadoControle' },
        { pontosdecontrole: resources.pontosdecontrole }
      )}
    >
      <div>{children}</div>
    </Tooltip>
  );

  const exibirCodigoAutomatico =
    !config?.model?.utilizarCodigoAutomatico ||
    (controleId > 0 && config?.model?.utilizarCodigoAutomatico);

  const isNew = model?.getModel('id')?.value === 0;

  return (
    <div>
      <Tabs>
        <Tab label={<FormattedMessage id="label.geral" />} key="1">
          <Row>
            {exibirCodigoAutomatico && (
              <Col md={2}>
                <Input
                  style={{ height: '38px' }}
                  disabled={isDisabled || bloquearCodigoAutomatico}
                  model={model.getModel('idIntegracao')}
                  required={!utilizarCodigoAutomatico}
                />
              </Col>
            )}
            <Col md={exibirCodigoAutomatico ? 5 : 6}>
              {renderInput(
                <Input
                  rows={1}
                  type="textarea"
                  style={{ height: '38px' }}
                  model={model.getModel('descricao')}
                  required
                  disabled={isDisabled || riscoControleView}
                  maxLength={1500}
                />
              )}
            </Col>
            <Col md={exibirCodigoAutomatico ? 5 : 6}>
              <ColaboradorEGrupoSimplificadoLookup
                abrirEmDrawer={true}
                showHint={
                  isDisabled ||
                  (config.model &&
                    !config.model.responsavelValidadorConformeRisco &&
                    riscoControleView)
                }
                hint={intl.formatMessage(
                  { id: 'labelCampoBloqueadoControle' },
                  { pontosdecontrole: resources.pontosdecontrole }
                )}
                disabled={
                  isDisabled ||
                  (config.model &&
                    !config.model.responsavelValidadorConformeRisco &&
                    riscoControleView)
                }
                required={responsavelObrigatorio && !agrupador}
                model={{
                  label: capitalizeFirstLetter(resources.responsavel),
                  value: model.getModel('responsavel').value,
                  requestChange: requestChangeResponsavel,
                  errors: model.getModel('responsavel').errors,
                }}
              />
            </Col>
          </Row>
          <Row>
            {!agrupador &&
              model.getModel('frequenciaControle').value &&
              model.getModel('frequenciaControle').value.id == 1 && (
                <Col md={2}>
                  {renderInput(
                    <InputNumber
                      model={model.getModel(
                        'numeroRevisoesGeradasAutomaticamente'
                      )}
                      disabled={isDisabled || riscoControleView}
                    />
                  )}
                </Col>
              )}
            <Col
              md={
                ehFrequenciaControleConstante || ehFrequenciaControleOcorrencia
                  ? 4
                  : 5
              }
            >
              {renderInput(
                <AreaLookup
                  clearable
                  disabled={isDisabled || riscoControleView}
                  model={{
                    label: capitalizeFirstLetter(resources.area),
                    value: model.getModel('area').value,
                    requestChange: model.getModel('area').requestChange,
                  }}
                />
              )}
            </Col>
            {!agrupador && config.model && config.model.frequenciaControle && (
              <Col
                md={
                  ehFrequenciaControleConstante ||
                  ehFrequenciaControleOcorrencia
                    ? 4
                    : 5
                }
              >
                {renderInput(
                  <FrequenciaControleLookup
                    model={{
                      label: intl.formatMessage({ id: 'label.frequencia' }),
                      value: model.getModel('frequenciaControle').value,
                      requestChange:
                        model.getModel('frequenciaControle').requestChange,
                      errors: model.getModel('frequenciaControle').errors,
                    }}
                    disabled={
                      model.getModel('bloquearCampoFrequenciaControle').value ||
                      riscoControleView
                    }
                    required
                  />
                )}
              </Col>
            )}
            {model.getModel('utilizarTipoEvidencia').value &&
              (ehFrequenciaControleConstante ||
                ehFrequenciaControleOcorrencia) && (
                <Col md={4}>
                  {renderInput(
                    <TipoEvidenciaLookup
                      multi
                      model={model.getModel('tipoEvidencias')}
                      disabled={isDisabled || riscoControleView}
                    />
                  )}
                </Col>
              )}
            {agrupador && (
              <Col md={4}>
                {renderInput(
                  <PontoControleLookup
                    model={{
                      label: intl.formatMessage({ id: 'labelPasta' }),
                      value: model.getModel('controlePai').value,
                      requestChange:
                        model.getModel('controlePai').requestChange,
                    }}
                    data={{
                      apenasPasta: true,
                      idRetirar: rest.idRetirar
                        ? rest.idRetirar
                        : model?.getModel('id')?.value,
                    }}
                    propsEdit={{
                      tipoInclusao: 2,
                      idRetirar: model?.getModel('id')?.value,
                    }}
                    clearable
                    disabled={isDisabled || itemOrigem}
                  />
                )}
              </Col>
            )}
          </Row>
          {!agrupador && (
            <Fragment>
              <Row>
                {model.getModel('frequenciaControle').value &&
                  model.getModel('frequenciaControle').value.id == 1 && (
                    <Col md={2}>
                      {renderInput(
                        <TipoPeriodicidadePontoControle
                          model={model.getModel('periodicidade')}
                          required={periodicidadeObrigatoria}
                          disabled={isDisabled || riscoControleView}
                        />
                      )}
                    </Col>
                  )}
                {((model.getModel('frequenciaControle').value &&
                  model.getModel('frequenciaControle').value.id == 1 &&
                  !ehPeriodicidadeConformeCalendario) ||
                  (model.getModel('frequenciaControle').value &&
                    model.getModel('frequenciaControle').value.id == 2)) && (
                  <React.Fragment>
                    <Col md={1}>
                      {renderInput(
                        <InputNumber
                          model={model.getModel('diasToleranciaRevisao')}
                          disabled={
                            model.getModel('bloquearCampoFrequenciaControle')
                              .value || riscoControleView
                          }
                        />
                      )}
                    </Col>
                    <Col md={4}>
                      {renderInput(
                        <TipoToleranciaLookup
                          style={{ marginTop: 27 }}
                          model={model.getModel('tipoTolerancia')}
                          disabled={
                            model.getModel('bloquearCampoFrequenciaControle')
                              .value || riscoControleView
                          }
                        />
                      )}
                    </Col>
                    {model.getModel('configurarCalendarioPontoControle')
                      .value && (
                      <Col md={5}>
                        {renderInput(
                          <CalendarioLookup
                            model={model.getModel('calendario')}
                            disabled={
                              model.getModel('bloquearCampoFrequenciaControle')
                                .value || riscoControleView
                            }
                          />
                        )}
                      </Col>
                    )}
                    {!ehPeriodicidadeConformeCalendario &&
                      model.getModel('avaliarConformidadeRevisaoControle')
                        .value &&
                      model.getModel('frequenciaControle').value &&
                      model.getModel('frequenciaControle').value.id == 1 && (
                        <Col md={5}>
                          <ColaboradorEGrupoSimplificadoLookup
                            abrirEmDrawer={true}
                            multi
                            disabled={
                              isDisabled ||
                              (config.model &&
                                !config.model
                                  .responsavelValidadorConformeRisco &&
                                riscoControleView)
                            }
                            model={{
                              label: intl.formatMessage({ id: 'validadores' }),
                              value: model.getModel('validadores').value,
                              requestChange: requestChangeValidadores,
                              errors: model.getModel('validadores').errors,
                            }}
                          />
                        </Col>
                      )}
                  </React.Fragment>
                )}
              </Row>
              {ehPeriodicidadeConformeCalendario &&
                !ehFrequenciaControleConstante &&
                !ehFrequenciaControleOcorrencia && (
                  <Row>
                    <Col md={12}>
                      {renderInput(
                        <Panel
                          header={capitalizeFirstLetter(
                            intl.formatMessage({
                              id: 'recorrenciasPeriodicidade',
                            })
                          )}
                        >
                          <RecorrenciaPeriodicidade
                            model={model.getModel('recorrenciasPeriodicidade')}
                            disabled={isDisabled || riscoControleView}
                          />
                        </Panel>
                      )}
                    </Col>
                  </Row>
                )}
              <Row>
                {exibirAnexoObrigatorio && (
                  <Col md={2}>
                    {renderInput(
                      <CheckBox
                        disabled={isDisabled || riscoControleView}
                        style={{ marginTop: 10 }}
                        model={{
                          label: intl.formatMessage({
                            id: 'anexoObrigatorio',
                          }),
                          value: model.getModel('anexoObrigatorio').value,
                          requestChange:
                            model.getModel('anexoObrigatorio').requestChange,
                        }}
                      />
                    )}
                  </Col>
                )}
                {ehPeriodicidadeConformeCalendario &&
                  model.getModel('avaliarConformidadeRevisaoControle').value &&
                  model.getModel('frequenciaControle').value &&
                  model.getModel('frequenciaControle').value.id == 1 && (
                    <Col md={5}>
                      <ColaboradorEGrupoSimplificadoLookup
                        abrirEmDrawer={true}
                        multi
                        disabled={
                          isDisabled ||
                          (config.model &&
                            !config.model.responsavelValidadorConformeRisco &&
                            riscoControleView)
                        }
                        model={{
                          label: intl.formatMessage({ id: 'validadores' }),
                          value: model.getModel('validadores').value,
                          requestChange: requestChangeValidadores,
                          errors: model.getModel('validadores').errors,
                        }}
                      />
                    </Col>
                  )}
                {model.getModel('utilizarTipoEvidencia').value &&
                  !ehFrequenciaControleConstante &&
                  !ehFrequenciaControleOcorrencia && (
                    <Col md={5}>
                      {renderInput(
                        <TipoEvidenciaLookup
                          multi
                          model={model.getModel('tipoEvidencias')}
                          disabled={isDisabled || riscoControleView}
                        />
                      )}
                    </Col>
                  )}
                {model.getModel('utilizarTipoPontoControle').value &&
                  !ehPeriodicidadeConformeCalendario &&
                  !ehFrequenciaControleConstante &&
                  !ehFrequenciaControleOcorrencia && (
                    <Col md={5}>
                      {renderInput(
                        <TipoPontoControle
                          id="tipoPontoControle"
                          disabled={isDisabled || riscoControleView}
                          clearable
                          model={{
                            label: intl.formatMessage(
                              { id: 'labelTipoPontoDeControle' },
                              { pontodecontrole: resources.pontodecontrole }
                            ),
                            value: model.getModel('tipoPontoControle').value,
                            requestChange:
                              model.getModel('tipoPontoControle').requestChange,
                            errors: model.getModel('tipoPontoControle').errors,
                          }}
                        />
                      )}
                    </Col>
                  )}
              </Row>
              <Row>
                {!agrupador &&
                  model.getModel('utilizarTipoPontoControle').value &&
                  (ehPeriodicidadeConformeCalendario ||
                    ehFrequenciaControleConstante ||
                    ehFrequenciaControleOcorrencia) && (
                    <Col md={4}>
                      {renderInput(
                        <TipoPontoControle
                          disabled={isDisabled || riscoControleView}
                          clearable
                          model={{
                            label: intl.formatMessage(
                              { id: 'labelTipoPontoDeControle' },
                              { pontodecontrole: resources.pontodecontrole }
                            ),
                            value: model.getModel('tipoPontoControle').value,
                            requestChange:
                              model.getModel('tipoPontoControle').requestChange,
                            errors: model.getModel('tipoPontoControle').errors,
                          }}
                        />
                      )}
                    </Col>
                  )}
                {config.model && config.model.funcaoPontoControle && (
                  <Col
                    md={
                      ehPeriodicidadeConformeCalendario ||
                      ehFrequenciaControleConstante ||
                      ehFrequenciaControleOcorrencia
                        ? 4
                        : 8
                    }
                  >
                    {renderInput(
                      <FuncaoPontoControlelookup
                        model={{
                          label: intl.formatMessage(
                            { id: 'funcaoPontoControle' },
                            { pontodecontrole: resources.pontodecontrole }
                          ),
                          value: model.getModel('funcaoPontoControle').value,
                          requestChange: handleChangeEfetividade,
                        }}
                        disabled={isDisabled || riscoControleView}
                        clearable
                      />
                    )}
                  </Col>
                )}
                {!agrupador && (
                  <Col md={4}>
                    {renderInput(
                      <PontoControleLookup
                        model={{
                          label: intl.formatMessage({ id: 'labelPasta' }),
                          value: model.getModel('controlePai').value,
                          requestChange: alterarPasta,
                        }}
                        data={{
                          apenasPasta: true,
                          idRetirar:
                            model &&
                            model.getModel('id') &&
                            model.getModel('id').value,
                        }}
                        clearable
                        disabled={isDisabled || itemOrigem || riscoControleView}
                      />
                    )}
                  </Col>
                )}
              </Row>
              {model.getModel('camposCustomizados').value &&
                model.getModel('camposCustomizados').value.length > 0 && (
                  <DesenharCampoCustomizado
                    model={model.getModel('camposCustomizados')}
                    disabled={isDisabled || riscoControleView}
                    maxLength={1500}
                  />
                )}
            </Fragment>
          )}
          {model.getModel('utilizarObservacao').value && (
            <Row>
              <Col md={12}>
                {renderInput(
                  <Input
                    rows={5}
                    type="textarea"
                    model={{
                      label: capitalizeFirstLetter(resources.observacao),
                      value: model.getModel('observacao').value,
                      requestChange: model.getModel('observacao').requestChange,
                    }}
                    disabled={isDisabled || riscoControleView}
                  />
                )}
              </Col>
            </Row>
          )}
          {!isNew && (
            <PanelCollapse
              open={false}
              header={intl.formatMessage({ id: 'label.historico' })}
              loadChildrenOnOpen={true}
            >
              <Historico
                url={`/PontoControle/ObterHistorico`}
                id={model.getModel('id').value}
              />
            </PanelCollapse>
          )}
        </Tab>
        {!agrupador &&
          configuracaoRisco &&
          configuracaoRisco.habilitarIndicadoresRisco &&
          model.getModel('frequenciaControle').value &&
          model.getModel('frequenciaControle').value.id == 2 &&
          controleId && (
            <Tab
              key="2"
              label={
                <FormattedMessage
                  id="indicadorRisco"
                  values={{ risco: resources.risco }}
                />
              }
            >
              <IndicadoresRiscoControleView
                controleId={controleId}
                closeModal={handleCloseEdit}
                disabled={isDisabled}
              />
            </Tab>
          )}
        {!isNew && !agrupador && showRevisoesControle && (
          <Tab
            key="3"
            label={
              <FormattedMessage
                id="revisoesPontoControle"
                values={{ revisoesdecontrole: resources.revisoesdecontrole }}
              />
            }
          >
            <RevisaoPontoControleList
              showTitle={false}
              showFastSearch={false}
              filterTag={FILTROS.REVISOES_PONTO_CONTROLE}
              columnsTag={COLUNAS.REVISOES_PONTO_CONTROLE}
              parameters={{ idPontoControle: model.getModel('id').value }}
              exibirAuditado={true}
              openLastFilter={false}
              utilizarClickRenderNomePontoControle={false}
              hideControlesFilter={true}
            />
          </Tab>
        )}
        {possuiAddonTesteControle &&
          !isNew &&
          !agrupador &&
          model.getModel('visualizarTesteControle').value && (
            <Tab
              key="4"
              label={intl.formatMessage(
                { id: 'labelTesteControle' },
                { testeControle: resources.testeControle }
              )}
            >
              <TesteControleView
                parameters={{ controleId: model.getModel('id').value }}
                disabled={isDisabled}
                showPanel={false}
                showNew={true}
                showSearch={false}
              />
            </Tab>
          )}
        {!isNew && !agrupador && (
          <Tab key={'5'} label={capitalizeFirstLetter(resources.planodeacao)}>
            <Acao
              parameters={{
                pontoControleId: model.getModel('id').value,
                exibirLookups: false,
                itemNaoObrigatorio: true,
                exibirCampoCodigoImportacao: true,
              }}
              exibirLookups={false}
              handleCloseModal={handleCloseEdit}
              showMenuToolBar={false}
              forceRefreshAfterChange={true}
              ignorarFiltroSalvo={true}
              desabilitarSincronizacao={true}
            />
          </Tab>
        )}
      </Tabs>
    </div>
  );
}

const beforeSave = (
  item,
  handleSave,
  intl,
  fechar,
  resources,
  itemOriginal
) => {
  const agrupador = item?.agrupador;

  if (
    !agrupador &&
    item.id > 0 &&
    item.frequenciaControle?.id &&
    item.frequenciaControle?.id == 1
  ) {
    item.tipoToleranciaAlterada =
      (!itemOriginal.periodicidade?.id && item.periodicidade?.id) ||
      itemOriginal.periodicidade.id !== item.periodicidade.id;

    if (item.tipoToleranciaAlterada) {
      const msg = (
        <span className="text-justify" style={{ whiteSpace: 'pre-wrap' }}>
          {intl.formatMessage(
            { id: 'messagemValidacaoPeriodicidadeControleMudanca' },
            { pontodecontrole: resources.pontodecontrole }
          )}
        </span>
      );
      ContentManager.addContent(
        <Confirm message={msg} handleConfirm={() => handleSave(fechar)} />
      );
    } else {
      handleSave(fechar);
    }
  } else {
    handleSave(fechar);
  }
};

const PontoControleEdit = ({
  resources,
  handleCloseDialog,
  afterSave,
  showDelete,
  onDeleting,
  handleSave,
  ...rest
}) => (
  <Edit
    url="/PontoControle"
    endpointRemove="/AtualizarStatusExcluido"
    title={capitalizeFirstLetter(resources.pontodecontrole)}
    formComponent={PontoControleEditForm}
    resources={resources}
    handleClose={handleCloseDialog && handleCloseDialog}
    handleConfirmeBeforeSave={beforeSave}
    afterSave={() => {
      handleCloseDialog && handleCloseDialog(true);
      afterSave && afterSave();
    }}
    schema={schema}
    width="70%"
    maxHeight="90%"
    showDelete={showDelete}
    showIconDelete={showDelete}
    onDeleting={onDeleting}
    showSaveClose={true}
    handleSave={handleSave}
    {...rest}
  />
);

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(PontoControleEdit));
